import * as React from 'react';
import { Languages } from '../shared/language/Language';

interface Props {
  onLanguageChange: (lng: Languages) => any;
  language?: Languages;
}

class LanguageSetter extends React.PureComponent<Props> {
  public componentDidMount() {
    if (this.props.language != null) {
      this.props.onLanguageChange(this.props.language);
    }
  }
  public componentDidUpdate() {
    if (this.props.language != null) {
      this.props.onLanguageChange(this.props.language);
    }
  }

  render() {
    return null;
  }
}
export default LanguageSetter;


// WEBPACK FOOTER //
// ./src/components/LanguageSetter.tsx